import {
  CURRENT_APP,
  DEFAULT_LANGUAGE,
  LANGUAGES,
  TRANSLATION_LOADING_CONFIG
} from 'domains/Translation/__constants__'
import Provider, { TranslationContext } from '@qonsoll/translation'

import { Box } from '@qonsoll/react-design'
import PropTypes from 'prop-types'
import Spinner from 'components/Spinner'
import database from 'services/firebase/database'
import { ref as databaseRef, update } from 'firebase/database'
import { useCallback, useEffect, useMemo, useRef } from 'react'
import readTranslationsWithRecovery from './readTranslationsWithRecovery'

const TranslationsProvider = (props) => {
  const { children } = props

  // [COMPUTED PROPERTIES]
  const loadingText = useMemo(
    () => TRANSLATION_LOADING_CONFIG?.[localStorage.getItem('language')],
    []
  )
  const stopReading = useRef(null)
  useEffect(() => () => stopReading.current?.(), [])
  const handleReadTranslations = useCallback((request) => {
    stopReading.current?.()
    stopReading.current = readTranslationsWithRecovery(request)
  }, [])
  const handleWriteTranslations = useCallback(
    ({ ref, value }) =>
      update(databaseRef(database, ref), value).catch(() => null),
    []
  )

  return (
    <Provider
      languages={LANGUAGES}
      defaultLanguage={DEFAULT_LANGUAGE}
      currentApp={CURRENT_APP}
      onRead={handleReadTranslations}
      onWrite={handleWriteTranslations}>
      <TranslationContext.Consumer>
        {({ loaded }) => (
          <Box width="inherit" height="inherit">
            {!loaded && (
              <Box
                position="fixed"
                bg="white"
                width="100vw"
                height="100vh"
                zIndex={1000}>
                <Spinner text={loadingText} />
              </Box>
            )}
            {children}
          </Box>
        )}
      </TranslationContext.Consumer>
    </Provider>
  )
}

TranslationsProvider.propTypes = {
  children: PropTypes.any
}

export default TranslationsProvider
